module.exports = __webpack_public_path__ + "img/redteaready.4848ed87.png";